export default "__VITE_ASSET__7P65SpHT__"